import React, { useCallback, useMemo } from "react";
import { getLang } from "@companion-core/web/src/Utilities/lang";
import { ButtonListLayoutProps } from "@companion-core/shared/app/Interfaces/blocks";
import { sanitizeHtml } from "@companion-core/shared/app/Utils/htmlSanitizer";
import { useDynamicPageStore } from "@companion-core/shared/app/Store/dynamicPageStore";
import { useConfigStore } from "@companion-core/shared/app/Store/configStore";
import "@companion-core/web/src/Assets/Styles/scss/buttonListLayout.scss";
import { getCloudinaryOptimizedUrl } from "@companion-core/shared/app/Utils/cloudinary";
import { getResolvedDescriptionAlt } from "@companion-core/shared/app/Utils/componentHelper";
import { ButtonListConfigItem } from "./buttonListLayout.model";

export const ButtonListLayout = ({ title, subtitle, cards, blockSlug }: ButtonListLayoutProps) => {
  const lang = getLang();
  const { blocksBySlug } = useDynamicPageStore();
  const colorIndex = useMemo(() => {
    return blocksBySlug[blockSlug ?? ""]?.colorIndex ?? 0;
  }, [blocksBySlug, blockSlug]);
  const { config } = useConfigStore((state) => ({
    config: state.config,
  }));

  const getButtonDetails = useCallback(
    (buttonLink: string): { buttonPlatform: string | null; buttonImage: string | null } => {
      const buttonConfig = config?.modules?.ButtonListConfig?.filter((item: ButtonListConfigItem) =>
        buttonLink.includes(item.link)
      );
      return {
        buttonPlatform: buttonConfig?.[0]?.platform ?? "default",
        buttonImage: buttonConfig?.[0]?.buttonImages?.[lang] ?? null,
      };
    },
    [config]
  );

  return (
    <section
      data-testid="block-buttonlist"
      className={`button-list-layout ${colorIndex % 2 === 0 ? "colored-background--odd" : "colored-background--even"}`}>
      <h2
        data-testid="block-buttonlist__title"
        className="super-title-3 button-list-layout__title"
        // nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(title) }}
      />
      {subtitle && (
        <span
          data-testid="block-buttonlist__subtitle"
          className="title-8 text-align-center margin-top-16"
          // nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(subtitle) }}
        />
      )}

      <div className="button-list-layout__store-button">
        {cards.map((content, index) => {
          const { buttonPlatform, buttonImage } = getButtonDetails(content?.button_link ?? "");

          return (
            <a
              key={`button-${index}`}
              href={content?.button_link}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`block-buttonlist-button-${buttonPlatform}`}>
              <img
                className={`button-list-layout__store-button--${buttonPlatform}_btn`}
                alt={getResolvedDescriptionAlt(
                  content?.medias?.[0]?.description_alt,
                  content?.button_title
                )}
                src={
                  buttonImage ??
                  getCloudinaryOptimizedUrl(content?.medias?.[0]?.url ?? "", {
                    contentType: "card",
                  })
                }
              />
            </a>
          );
        })}
      </div>
    </section>
  );
};
